<template>
  <main class="page">
      <div class="page__main">
          <img class="property-valuation" src="../assets/img/property-valuation.jpg" alt="property valuation">
      </div>
  </main>
</template>

<script>

export default {
  name: 'PropertyValuation',
}
</script>

<style scoped>

.property-valuation{
    display: block;
    max-width: 900px;
    width:  100%;
    height: auto;
    margin: auto;
}

</style>